<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        :is-height="false"
        url="productionOrders"
        :table-footer-msg="tableFooterMsg"
        @select="selectHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @update="getTableFooterMsg">
      <template slot="otherBtn">
        <!--        <el-button type="primary" @click="$refs.productionPlanEdit.open(0)"> 新建</el-button>-->
        <el-button v-if="labelPrintAuth" :disabled="selection.length!==1" type="primary" @click="printLabel">
          打印标签
        </el-button>
        <el-button v-if="limits.delAuth" type="danger" :disabled="!selection.length" @click="deleteBatch"> 批量删除
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
            <el-form-item label="工单编号">
              <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入工单编号" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <!--            <el-form-item label="物料类型">-->
            <!--              <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>-->
            <!--                <el-option-->
            <!--                    v-for="item in materialTypeList"-->
            <!--                    :key="item.pkid"-->
            <!--                    :label="item.materialTypeName"-->
            <!--                    :value="item.pkid"/>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="物料类型">
              <el-select
                  v-model="materialTypeList"
                  :popper-append-to-body="false"
                  class="biddingStageSty"
                  multiple
                  clearable
                  placeholder="请选择"
                  @change="handleSelectMaterialtype">
                <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name"
                           :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料规格">
              <el-input v-model.trim="filter.materialSpecification" placeholder="请输入物料规格" clearable/>
            </el-form-item>
            <el-form-item label="工单类型：">
              <el-select v-model="filter.productionOrderType" placeholder="请选择工单类型" clearable>
                <el-option label="销售订单" :value="1"/>
                <el-option label="自制工单" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="工艺路线">
              <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
            </el-form-item>
            <el-form-item label="销售单号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售订单编号" clearable/>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="最终客户">
              <el-input v-model.trim="filter.finalCustomerName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="合同号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>
            </el-form-item>
            <el-form-item label="计划开工日期">
              <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('dateRange', 'planStartFrom', 'planStartTo')"/>
            </el-form-item>
            <el-form-item label="计划完工日期">
              <el-date-picker
                  v-model="finishDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('finishDateRange', 'planFinishFrom', 'planFinishTo')"/>
            </el-form-item>
            <el-form-item label="下单日期">
              <el-date-picker
                  v-model="submitDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitDateRange', 'soSubmitStartTime', 'soSubmitEndTime')"/>
            </el-form-item>
            <el-form-item label="交货日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'soDeliveryStartDate', 'soDeliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="派工状态">
              <el-select v-model="filter.dispatchStatus" placeholder="请选择派工状态" clearable>
                <el-option label="未派工" :value="1"/>
                <el-option label="派工中" :value="2"/>
                <el-option label="已派工" :value="3"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.taskAddAuth"
            type="primary"
            :disabled="scope.row.leftQuantity <= 0"
            @click="createTask(scope.row)">
          派工
        </el-button>
      </template>
    </view-table>
    <production-plan-edit ref="productionPlanEdit" @save-success="loadData(1)"/>
    <print-out-stock-order-modal ref="printOutStockDelivery"/>
    <delivery-notice-label ref="deliveryNoticeLabel"/>
    <work-order-issued-edit ref="workOrderIssuedEdit" :product-order-info="orderInfo" @save-success="loadData(1)"/>
    <material-stock-preview ref="stockPreview"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import ProductionPlanEdit from "./ProductionPlanEdit";
  import WorkOrderIssuedEdit from "@/views/ProductionManagement/ProductionPlan/WorkOrderIssuedEdit";
  import PrintOutStockOrderModal from "@/views/StoreManagement/OutStockDelivery/PrintOutStockDelivery";
  import DeliveryNoticeLabel from "@/views/StoreManagement/OutStockDelivery/DeliveryNoticeLabel";
  import MaterialStockPreview from "@/views/ProductionManagement/ProductionProject/MaterialStockPreview";

  export default {
    name: "ProductionPlanList",
    components: {
      ViewTable,
      ProductionPlanEdit,
      WorkOrderIssuedEdit,
      PrintOutStockOrderModal,
      DeliveryNoticeLabel,
      MaterialStockPreview,
    },
    data() {
      return {
        limits: {
          delAuth: this.$auth(16),
          editAuth: this.$auth(14),
          addAuth: this.$auth(13),
          taskAddAuth: this.$auth(14),
        },
        labelPrintAuth: this.$auth(405),
        currentRowIndex: 0,
        pkId: 0,
        activeName: "",
        ids: [],
        dateRange: [],
        finishDateRange: [],
        submitDateRange: [],
        deliveryDateRange: [],
        searchShow: false,
        selection: [], // 当前选中的数据
        materialTypeList: [],
        materialTypeOptions: [],
        filter: {
          productionOrderNo: "",
          materialName: "",
          materialNo: "",
          materialTypeId: "",
          materialTypeIds: "",
          materialSpecification: "",
          productionOrderType: "",
          routingName: "",
          salesOrderNo: "",
          customerName: "",
          finalCustomerName: "",
          customerContractNo: "",
          planStartFrom: "",
          planStartTo: "",
          planFinishFrom: "",
          planFinishTo: "",
          soSubmitStartTime: "",
          soSubmitEndTime: "",
          soDeliveryStartDate: "",
          soDeliveryEndDate: "",
          dispatchStatus: "",
        },
        orderInfo: null,
        // grantColumns: [
        //   {name: "routingName", label: "工艺路线", align: "center", width: 100},
        //   {name: "quantity", label: "生产数量", align: "center", width: 60},
        // ],
        columnsProperty: [
          {
            key: "productionOrderNo",
            width: 160,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: params.row.purchaseStatus === "缺料" ? "" : "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.productionPlanEdit.open(params.row.pkid, true);
                      },
                    },
                  },
                  params.row.productionOrderNo,
              );
            },
          },
          {
            title: "采购到料状态",
            key: "purchaseStatus",
            width: 100,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: params.row.purchaseStatus === "缺料" ? "" : "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (params.row.purchaseStatus) {
                          this.$refs.stockPreview.open(params.row.productionOrderNo, true);
                        }
                      },
                    },
                  },
                  params.row.purchaseStatus,
              );
            },
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
        tableFooterMsg: "",
      };
    },
    watch: {
      "filter.planStartFrom": {
        handler(newVal) {
          if (newVal) {
            this.dateRange = [];
            this.dateRange.push(this.filter.planStartFrom);
            this.dateRange.push(this.filter.planStartTo);
          }
        },
      },
      "filter.planFinishFrom": {
        handler(newVal) {
          if (newVal) {
            this.finishDateRange = [];
            this.finishDateRange.push(this.filter.planFinishFrom);
            this.finishDateRange.push(this.filter.planFinishTo);
          }
        },
      },
      "filter.soSubmitStartTime": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.soSubmitStartTime);
            this.submitDateRange.push(this.filter.soSubmitEndTime);
          }
        },
      },
      "filter.soDeliveryStartDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.soDeliveryStartDate);
            this.deliveryDateRange.push(this.filter.soDeliveryEndDate);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },
    created() {
      this.getMaterialTypeList();
    },
    mounted() {
      // this.loadData(1);
      // this.dateRange.push(this.$moment().format("yyyy-MM-DD"), this.$moment().add(6, "months").format("yyyy-MM-DD"));
      // this.filter.planStartFrom = this.dateRange[0];
      // this.filter.planStartTo = this.dateRange[1];
    },
    methods: {
      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelectMaterialtype(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      getTableFooterMsg() {
        this.tableFooterMsg = "总数量:0";
        this.$http.get("basic", "productionOrders/selectCount", this.filter).then((res) => {
          if (res.success) {
            this.tableFooterMsg = "总数量:" + res.data;
          }
        });
      },
      createTask(row) {
        this.$http.get("basic", `productionOrders/${row.pkid}`).then((resp) => {
          if (resp.success) {
            this.orderInfo = resp.data;
            this.orderInfo.materialTypeNo = row.materialTypeNo;
            this.$refs.workOrderIssuedEdit.open(0, false, this.orderInfo);
          }
        });
      },
      loadData(pageNum) {
        this.getTableFooterMsg();
        this.$refs.viewTable.loadData(pageNum);
      },

      selectHandle(selection) {
        this.ids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.pkid);
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        if(row){
          this.$refs.productionPlanEdit.open(row.pkid, false);
        }else{
          this.$refs.productionPlanEdit.open(0, false);

        }
      },

      // 删除
      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "productionOrders", row.pkid).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
            }
          });
        });
      },

      // 批量删除
      deleteBatch() {
        // const arr = this.selection.filter((item) => item.status !== 0);
        // if (arr.length) {
        //   this.$confirm("请选择未提交状态的订单", "错误", {
        //     type: "error",
        //     showCancelButton: false,
        //   });
        //   return;
        // }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "productionOrders/deleteBatch", this.ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      //非已派工，可以编辑删除
      otherAuth(row) {
        if (row.leftQuantity > 0) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
      // 查询条件：开工时间(dateRange)、完工时间(finishDateRange)
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
      // 重置时单独处理开工时间、完工时间
      handleClick() {
        this.dateRange = [];
        this.finishDateRange = [];
        this.deliveryDateRange = [];
        this.submitDateRange = [];
      },
      // 点击行并选中
      rowClick(row) {
        const tableData = this.$refs.vmTable.tableData;
        tableData.forEach((item, index) => {
          if (item.pkid === row.pkid) {
            this.currentRowIndex = index;
            this.pkId = row.pkid;
          }
        });
      },
      printLabel() {
        const labelData = {
          customerNo: this.selection[0].customerOuterNo,
          billNo: this.selection[0].productionOrderNo,
          orderNo: this.selection[0].productionOrderNo,
          materialName: this.selection[0].materialName,
          quantity: this.selection[0].quantity,
          specification: this.selection[0].specification,
          amount: 1,
          note: this.selection[0].salesOrderMaterialNote,
          date: this.$moment().format("yyyy-MM-DD"),
          manufactor: "上海鸿康电器有限公司",
          telephone: "021-37701209",
          pkid: 0,
        };
        if (this.selection[0].finalCustomerOuterNo) {
          labelData.customerNo = this.selection[0].finalCustomerOuterNo;
        }
        this.$refs.deliveryNoticeLabel.open(labelData);
        // this.$refs.vmTable.tableData.forEach((item) => {
        //   if (item.pkid === this.pkId) {
        //     console.log(item);
        //     const labelData = {
        //       customerNo: item.customerName,
        //       billNo: item.productionOrderNo,
        //       materialName: item.materialName,
        //       quantity: item.quantity,
        //       specification: item.specification,
        //       amount: 1,
        //       note: "",
        //       date: this.$moment().format("yyyy-MM-DD"),
        //       manufactor: "上海鸿康电器有限公司",
        //       telephone: "021-37701209",
        //     };
        //     if (item.finalCustomerName) {
        //       labelData.customerNo = item.finalCustomerName;
        //     }
        //     this.$refs.deliveryNoticeLabel.open(labelData);
        //   }
        // });
      },
    },
  };
</script>


<style>
.batchElTabs .el-tabs__header {
  margin-bottom: 8px;
}
</style>
